module.exports = __webpack_public_path__ + "static/media/paymentCheckout.399130ec.svg";